<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i
      class="fa"
      [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
      style="margin-right: 10px; cursor: pointer;"
      (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form name="projectTagForm" id="projectTagForm" novalidate>
    <div style="margin-bottom: 12px;">
      <b>Key:</b>
      <div class="badge btn-info">LEID - CDR - RPT.PD - BSLA - CUR</div>
      <i style="font-size: 11px;">( * hover on entities to view Schedule M User Description )</i>
    </div>

    <div class="entitie-holder">
      @for (entity of entities; track $index; let i = $index) {
<div
        class="btn-group dropup pull-left"
       
        [title]="entity?.data?.SCHDM_USER_DESC || ''">
        <button type="button" class="btn btn-xs btn-default">
          {{ entity?.data?.LEID }} - {{ entity?.data?.CDR_NO }} - {{ entity?.data?.REPORTING_PERIOD }} - {{ entity?.data?.BSLA_CODE }} - {{ entity?.data?.CURRENCY }}
        </button>
        <button
          type="button"
          (click)="removeEntity(i)"
          class="btn btn-xs btn-danger dropdown-toggle"
          aria-haspopup="true"
          aria-expanded="false">
          <span class="fa fa-times"></span>
        </button>
      </div>
}
    </div>

    <div class="panel panel-default" style="margin-top: 12px;">
      <div class="panel-body">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-5">
              <label for="project">Project</label>
              <div>
                <select
                  id="project"
                  class="form-control"
                  name="project"
                  [ngModel]="project"
                  (ngModelChange)="project = $event; loadProjectSteps()"
                  required>
                  <option value="" selected="selected">Please Select a Project</option>
                  @for (item of projectList; track $index) {
<option [ngValue]="item">{{ item.PROJECT_NAME }}</option>
}
                </select>
              </div>
              @if (formSubmitted && !project) {
<span class="form-error-container">Please select a project</span>
}

              <hr />
              <label for="projectStep">Project Step</label>

              <div [hidden]="hideProjectSteps">
                <select
                  class="form-control"
                  name="projectStep"
                  id="projectStep"
                  [ngModel]="projectStep"
                  (ngModelChange)="projectStep = $event">
                  <option [ngValue]="null" selected="selected">Select Project Step...</option>
                  @for (item of projectStepList; track $index) {
<option [ngValue]="item">{{ item.LABEL }}</option>
}
                </select>
              </div>

              <div [hidden]="!hideProjectSteps">
                <span class="badge btn-info">No Steps For this project</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
